import React from 'react'
import xss from 'xss'

import { Avatar } from '@wartek-id/avatar'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text'

import { capitalizeFirstLetter } from 'utils/text'

import type { PlaylistsReviewer, PlaylistVideo } from 'types/video-inspirasi'

interface PlaylistInfoDialogProps {
  isOpen: boolean
  onClose: () => void
  name: string
  shortDescription: string
  longDescription: string
  videos: PlaylistVideo[]
  reviewer: PlaylistsReviewer
}

const PlaylistInfoDialog = ({
  isOpen,
  onClose,
  name,
  shortDescription,
  longDescription,
  videos,
  reviewer,
}: PlaylistInfoDialogProps) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} size="lg">
      <DialogOverlay />
      <DialogContent>
        <DialogCloseButton />
        <div className="p-6">
          <Text variant="heading-lg" className="mb-3">
            {name}
          </Text>
          <Text color="subdued" className="mb-4">
            {capitalizeFirstLetter(shortDescription)}
          </Text>

          <div className="border-t border-subdued pt-4">
            <Text
              className="simple-wysiwyg-content material-content video-inspirasi"
              dangerouslySetInnerHTML={{
                __html: xss(longDescription),
              }}
            />
          </div>

          <div className="border-t border-subdued pt-4 mt-4">
            <Text variant="heading-sm" className="mb-2">
              Daftar Video:
            </Text>
            <ul className="list-disc pl-7">
              {videos?.map((video, index) => (
                <li className="text-subdued" key={video.videoId + index}>
                  <Text color="subdued">{video.title}</Text>
                </li>
              ))}
            </ul>
          </div>

          {reviewer && (
            <div className="border-t border-subdued pt-4 mt-4">
              <div className="flex items-center mb-3">
                <Avatar
                  alt=""
                  shape="circle"
                  size="xl"
                  src={reviewer.imageUrl}
                />
                <div className="ml-3">
                  <Text variant="body-sm">Dikurasi oleh</Text>
                  <Text variant="heading-sm">{reviewer.name}</Text>
                </div>
              </div>
              <Text variant="body-sm">{reviewer.about}</Text>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default PlaylistInfoDialog
